import {gql} from "@apollo/client";
import {Project, ChallengeEducationState} from "../../schema";
import ChallengeCard, {QueryData as ChallengeCardQueryData} from "../../components/ChallengeCard";

export type QueryVars = {
  projectId: Project["id"]
}

export type QueryData = {
  project: Pick<Project, "__typename" | "id" | "name" | "accessToken"> & ChallengeCardQueryData["project"] & {
    challenges: ChallengeCardQueryData["challenge"][]
  },
  challengesStates: (
    Pick<ChallengeEducationState, "__typename" | "challengeId" | "resultDescription" | "isCompleted">
    & ChallengeCardQueryData["challengeState"]
  )[] | null
}

export const query = gql`
  query PlayerProjectSceneQuery($projectId: ID!) {
    project: getProject(projectId: $projectId) {
      __typename
      id
      name
      accessToken
      challenges {
        ...ChallengeCard
      }
      ...ChallengeCardProject
    }

    challengesStates: getChallengesEducationState(projectId: $projectId) {
      __typename
      challengeId
      resultDescription
      ...ChallengeCardState
    }
  }
  ${ChallengeCard.fragments.root}
  ${ChallengeCard.fragments.project}
  ${ChallengeCard.fragments.state}
`;
